import { boolean, pgEnum, pgTable, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { users } from "./users"

export const apiClientScopeEnum = pgEnum("api_client_scope_enum", ["FULL_ACCESS", "READ_ONLY"])

export const apiClients = pgTable("api_client", {
  id: uuid("id").primaryKey().defaultRandom(),
  cognitoClientId: varchar("cognito_client_id", { length: 255 }).notNull().unique(),
  userId: varchar("user_id", { length: 255 })
    .notNull()
    .references(() => users.id, { onDelete: "cascade" }),
  name: varchar("name", { length: 255 }).notNull(),
  scope: apiClientScopeEnum("scope").notNull().default("FULL_ACCESS"),
  isActive: boolean("is_active").notNull().default(true),
  lastUsedAt: timestamp("last_used_at"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
  // a database trigger is required. This schema sets the timestamp on creation,
  // and application logic or a trigger should handle updates.
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
